import React from 'react'
import { Link } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import {  Card, CardContent, Grid, IconButton, Typography } from '@mui/material'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';


const ProjectComponent = ({projects,footer=false}) => {
    return (
        <Card sx={{backgroundColor:'#ffffff'}}>
            <CardContent>
            <Typography variant={"h4"} sx={{mb:3}}>
                Recent Projects
            </Typography>
            {projects?.data?.map(element => (
                <Grid className='cardComp' container justifyContent="space-between" alignItems="center">
                <Grid item xs={10.5}>
                    <Grid 
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                    >
                    <IconButton color="inherit"><DescriptionIcon /></IconButton>
                    <Typography>{element.project_name}</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={1.5}>
                    <IconButton
                    component={Link}
                    to={'/config/projects-list'}
                    color="inherit"
                    ><KeyboardArrowRightRoundedIcon />
                    </IconButton>
                </Grid>
                </Grid>
            ))}
            {footer &&
                <Grid
                    className='cardCompFooter' container justifyContent="space-between" alignItems="center"
                >
                    <Grid item xs={12}>
                        <Grid 
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <IconButton 
                                component={Link} 
                                to={'/config/add-project'} 
                                color='inherit'
                                size='small'
                            >
                                <AddCircleOutlineRoundedIcon />
                            </IconButton>
                            <Typography variant="body2">Add New Project</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            }
            </CardContent> 
        </Card>
    )
}

export default ProjectComponent